import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6d0d019e")
const _hoisted_1 = {
  key: 0,
  class: "paypalWrapper",
  ref: "paypal"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Purchased", -1)
const _hoisted_4 = [
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.paidFor)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, null, 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}